export default {
  "luckywheelRecord.thead.userNo": "用户编号",
  "luckywheelRecord.thead.email": "邮箱",
  "luckywheelRecord.thead.rewardType": "奖励类型",
  "luckywheelRecord.thead.rewardName": "奖励名称",
  "luckywheelRecord.thead.rewardAmount": "奖励金额",
  "luckywheelRecord.thead.createTime": "创建时间",
  "luckywheelRecord.thead.resultTime": "结算时间",
  "luckywheelRecord.thead.recordId": "记录ID",
  "luckywheelRecord.thead.taskId": "任务ID",
  "luckywheelRecord.thead.name": "名称",
  "luckywheelRecord.thead.firstName": "名",
  "luckywheelRecord.thead.lastName": "姓",
  "luckywheelRecord.thead.process": "砍一刀金额",
  "luckywheelRecord.thead.afterProcess": "目前任务进度",
  "luckywheelRecord.thead.spin": "当前是第几刀",
  "luckywheelRecord.thead.expireTime": "过期时间",
  "luckywheelRecord.thead.spinTime": "转盘时间",
  "luckywheelRecord.thead.inviteRiskIp": "预警提示",
  "luckywheelRecord.column.status": "轮盘状态",
  "luckywheelRecord.title": "幸运轮盘记录",
};
